module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.0a74e46.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBold.eot
// module id = +/Ql
// module chunks = 3